export default function JoinDiscord() {
  return <a
            href="https://discord.gg/axhAP3ZVbe"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              textDecoration: 'none',
              background: 'linear-gradient(135deg, #5865F2 0%, #4752C4 100%)',
              borderRadius: '6px',
              boxShadow: '0 4px 12px rgba(88, 101, 242, 0.25)',
              transition: 'all 0.3s ease',
              cursor: 'pointer',
              border: 'none',
              textAlign: 'center',
              width: '100%',
              maxWidth: '360px',
              padding: '6px 16px',
            }}
          >
            <span style={{ 
              color: '#fff', 
              fontSize: 'clamp(14px, 3.5vw, 18px)',
              fontWeight: 500,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px'
            }}>
              🎮 Join Discord
            </span>
          </a>
}
